import { createContext } from 'react'

import type { CurrentAccountUser } from 'src/api/main'

type SessionContextType = {
  user?: CurrentAccountUser
  isLoading: boolean
  activeWorkspaceId?: number
  /**
   * The workspace the user *intentionally* used last (persisted only when they
   * enter or pick a workspace — never the post-login fallback). Drives the
   * landing decision; `undefined` means "no remembered choice".
   */
  storedWorkspaceId?: number
  setActiveWorkspaceId: (workspaceId?: number) => void
  updateUserData: (user?: CurrentAccountUser) => void
  /**
   * Signs out. Pass `redirectTo` (an internal path) to return to that page's
   * login screen with the destination preserved via the existing `?redirect=`
   * convention (see `UserSessionContextProvider`) — e.g. "sign in with a
   * different account" from a workspace-access-denied screen.
   */
  removeUserData: (options?: { redirectTo?: string }) => void
  refreshSession: () => Promise<unknown>
}

const initialSessionContext: SessionContextType = {
  user: undefined,
  isLoading: false,
  activeWorkspaceId: undefined,
  storedWorkspaceId: undefined,
  setActiveWorkspaceId: () => null,
  updateUserData: () => null,
  removeUserData: () => null,
  refreshSession: () => Promise.resolve()
}

export const UserSessionContext = createContext(initialSessionContext)
